import './EstimationV2.scss';

class EstimationV2 {

  constructor(node) {
    this.node = node;
    this.btnSend = document.querySelector('.e2-step button[type="submit"]');
    this.e2Steps = document.querySelectorAll(".e2-step:not(.e2-step--end)");
    this.rodo = document.getElementById("e2-rodo");
    this.range = document.getElementById("e2-range");
    this.rangeText = document.getElementById("range-score");
    this.inputReturnRange = document.getElementById("return-range");
  }

  init() {
    // this.hidenSend();
    this.checkSteps()
    // this.rodo.addEventListener("click", e => { this.checkSend() })

    this.range.addEventListener("input", (el) => {
      this.range.classList.add('active')

      let vale = "";
      switch (el.target.value) {
        case "1":
          vale = "<30 k USD"
          break;
        case "2":
          vale = "30 - 100 k USD"
          break;
        case "3":
          vale = "100 - 300 k USD"
          break;
        case "4":
          vale = "300 - 500 k USD"
          break;
        case "5":
          vale = ">500 k USD"
          break;

        default:
          vale = ""
          break;
      }
      this.rangeText.textContent = vale
      this.inputReturnRange.value = vale
    })
  }

  checkSteps() {
    this.e2Steps.forEach(step => {
      const fild = step.querySelector('textarea, select, input');
      if (!fild) return;

      fild.addEventListener("input", (event) => {

        if (event.target.value.length > 0) {
          step.classList.add("completed")
          // this.checkSend()
        } else {
          step.classList.remove("completed")
          // this.hidenSend()
        }
      }
        , false);
    });
  }

  checkSend() {
    if (this.e2Steps.length === document.querySelectorAll(".e2-step.completed:not(.e2-step--end)").length && this.rodo.checked) {
      this.showSend()
    } else {
      this.hidenSend();
    }
  }

  showSend() {
    this.btnSend.classList.remove("disabled")
  }

  hidenSend() {
    this.btnSend.classList.add("disabled")
  }

}

JSModules['EstimationV2'] = EstimationV2;
export default EstimationV2;
